var map = {
	"./marketing/marketing.module": [
		"./src/app/pages/metrics/marketing/marketing.module.ts",
		"default~marketing-marketing-module~pages-analytics-analytics-module~pages-investment-investment-modu~dc5c72e1",
		"default~marketing-marketing-module~pages-analytics-analytics-module~pages-investment-investment-module"
	],
	"./pages/analytics/analytics.module": [
		"./src/app/pages/analytics/analytics.module.ts",
		"default~marketing-marketing-module~pages-analytics-analytics-module~pages-investment-investment-modu~dc5c72e1",
		"default~marketing-marketing-module~pages-analytics-analytics-module~pages-investment-investment-module",
		"default~pages-analytics-analytics-module~sales-sales-module",
		"pages-analytics-analytics-module"
	],
	"./pages/calendar/calendar.module": [
		"./src/app/pages/calendar/calendar.module.ts",
		"pages-calendar-calendar-module"
	],
	"./pages/dashboard-bdc/dashboard-bdc.module": [
		"./src/app/pages/dashboard-bdc/dashboard-bdc.module.ts",
		"common",
		"pages-dashboard-bdc-dashboard-bdc-module"
	],
	"./pages/dashboard/dashboard.module": [
		"./src/app/pages/dashboard/dashboard.module.ts",
		"common",
		"pages-dashboard-dashboard-module"
	],
	"./pages/investment/investment.module": [
		"./src/app/pages/investment/investment.module.ts",
		"default~marketing-marketing-module~pages-analytics-analytics-module~pages-investment-investment-modu~dc5c72e1",
		"default~pages-investment-investment-module~pages-profile-profile-module~pages-reporting-reporting-module",
		"default~marketing-marketing-module~pages-analytics-analytics-module~pages-investment-investment-module",
		"common",
		"pages-investment-investment-module"
	],
	"./pages/leads/leads.module": [
		"./src/app/pages/leads/leads.module.ts",
		"common",
		"pages-leads-leads-module"
	],
	"./pages/metrics/metrics.module": [
		"./src/app/pages/metrics/metrics.module.ts",
		"pages-metrics-metrics-module"
	],
	"./pages/my-lead/my-lead.module": [
		"./src/app/pages/my-lead/my-lead.module.ts",
		"pages-my-lead-my-lead-module"
	],
	"./pages/new-dashboard/new-dashboard.module": [
		"./src/app/pages/new-dashboard/new-dashboard.module.ts",
		"default~marketing-marketing-module~pages-analytics-analytics-module~pages-investment-investment-modu~dc5c72e1",
		"common",
		"pages-new-dashboard-new-dashboard-module"
	],
	"./pages/profile/profile.module": [
		"./src/app/pages/profile/profile.module.ts",
		"default~pages-investment-investment-module~pages-profile-profile-module~pages-reporting-reporting-module",
		"default~pages-profile-profile-module~pages-security-security-module",
		"common",
		"pages-profile-profile-module"
	],
	"./pages/quotations/quotations.module": [
		"./src/app/pages/quotations/quotations.module.ts",
		"pages-quotations-quotations-module"
	],
	"./pages/reporting/reporting.module": [
		"./src/app/pages/reporting/reporting.module.ts",
		"default~pages-investment-investment-module~pages-profile-profile-module~pages-reporting-reporting-module",
		"pages-reporting-reporting-module"
	],
	"./pages/security/security.module": [
		"./src/app/pages/security/security.module.ts",
		"default~pages-profile-profile-module~pages-security-security-module"
	],
	"./sales/sales.module": [
		"./src/app/pages/metrics/sales/sales.module.ts",
		"default~marketing-marketing-module~pages-analytics-analytics-module~pages-investment-investment-modu~dc5c72e1",
		"default~pages-analytics-analytics-module~sales-sales-module"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;